module.exports = __webpack_public_path__ + "static/media/equipment.72acc5f6.png";